import React from "react";
import "./PackageTile.css";

/** The package marks of the Plans page: Kjuup = chat, Kjuup+ = award, Kjuup.io = sparkles. */
export const PACKAGE_ICONS = { kjuup: "chat", plus: "workspace_premium", io: "auto_awesome" };

/**
 * Package icon tile: the package's glyph in white on a rounded square in the package colour.
 * Used wherever a package is named (Plans page, cockpit offers, sidebar), so it reads the same.
 * size: "sm" 24 (sidebar, offer header) · "lg" 40 (Plans page).
 */
export default function PackageTile({ pkg, size = "lg", className = "" }) {
  return (
    <span className={`kj-pkg-tile kj-pkg-tile--${pkg} kj-pkg-tile--${size} ${className}`.trim()} aria-hidden="true">
      <span className="kj-pkg-tile__glyph">{PACKAGE_ICONS[pkg]}</span>
    </span>
  );
}
